import { Grid, MenuButtonList, Button } from "../../../../components";

const ButtonMenu = ({
  onClickCancelarMdfe,
  onClickEmitirMdfe,
  onClickVisualizarMdfe,
  onClickEncerrarMdfe,
  onClickBaixarXml,
  status,
}) => {
  const opcoesMenu = [
    { label: "Cancelar MDFE", onClick: onClickCancelarMdfe },
    { label: "Visualizar MDFE", onClick: onClickVisualizarMdfe },
    { label: "Baixar Xml", onClick: onClickBaixarXml },
  ];

  const renderEmitirButtons = () => {
    switch (status) {
      case "PENDENTE":
        return (
          <Button
            className="my-3 ms-2"
            variant="outlined"
            color="primary"
            size="small"
            onClick={onClickEmitirMdfe}
          >
            Emitir MDFE
          </Button>
        );
      case "ENVIADA":
        return (
          <MenuButtonList
            className="my-3 ms-2"
            botaoPrincipal={{
              onClick: onClickEncerrarMdfe,
              label: "Encerrar MDFE",
            }}
            opcoes={opcoesMenu}
          />
        );
      default:
        return (
          <Button
            className="my-3 ms-2"
            variant="outlined"
            color="primary"
            size="small"
            onClick={onClickVisualizarMdfe}
          >
            Visualizar MDFE
          </Button>
        );
    }
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ mb: "0.5em" }}
      >
        {renderEmitirButtons()}
      </Grid>
    </>
  );
};

export default ButtonMenu;
